import * as Yup from "yup";

export const AddExtraPointInitialState = {
  team: "",
};

export const AddExtraPointValidationSchema = Yup.object({
  team: Yup.string().required("Este campo es requerido"),
});
